import { render, staticRenderFns } from "./attparamdiolg.vue?vue&type=template&id=f01293fa&scoped=true"
import script from "./attparamdiolg.vue?vue&type=script&lang=js"
export * from "./attparamdiolg.vue?vue&type=script&lang=js"
import style0 from "./attparamdiolg.vue?vue&type=style&index=0&id=f01293fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01293fa",
  null
  
)

export default component.exports